export function isErrorWithMessageCap(
	error: unknown
): error is { data: { Error: string } } {
	if (typeof error === 'object' && error !== null && 'data' in error) {
		const data = (error as { data?: unknown }).data;
		return typeof data === 'object' && data !== null && 'Error' in data;
	}

	return false;
}

export function isErrorWithMessage(
	error: unknown
): error is { data: { error: string } } {
	if (typeof error === 'object' && error !== null && 'data' in error) {
		const data = (error as { data?: unknown }).data;
		return typeof data === 'object' && data !== null && 'error' in data;
	}

	return false;
}
